import {observer} from "mobx-react";
import * as React from "react";
import {action, computed, observable} from "mobx";
import { QuizQuestion} from "components/quiz/QuizQuestion";
import { RadioQuestionOption} from "components/quiz/RadioQuestionOption";
import {UserAnswer} from "components/quiz/UserAnswer";
import {isEmpty} from "../../utils";
import { v4 as uuidv4 } from 'uuid';


interface IRadioQuestion_Props {
  userAnswer:UserAnswer;
  answerLocked:boolean;
  questionId:string;
}

@observer
export class RadioQuestion extends React.Component<IRadioQuestion_Props> {

  @observable wrongAnswer = '';
  radioQuestionId:string;

  constructor(props) {
    super(props);
    this.radioQuestionId = uuidv4();
  }


  @action handleQuestionAnswered = (answerIndex?, wrongAnswerCallback?) => {
    this.handleClearAnswerFeedback();
    if (answerIndex !== undefined && answerIndex != null) {
      if(this.props.userAnswer.step.hasCorrectAnswer) {
        if (this.props.userAnswer.step.correctAnswer != answerIndex) {
          this.wrongAnswer = "Incorrect answer!";
          this.props.userAnswer.answerValue = '';
          if(wrongAnswerCallback) {
            wrongAnswerCallback();
          }
          return;
        } else {
          this.wrongAnswer = "Correct answer!";
          this.props.userAnswer.answerValue = answerIndex;
        }
      } else {
        this.props.userAnswer.answerValue = answerIndex;
      }
    }
  }

  @action handleClearAnswerFeedback = () => {
    this.wrongAnswer = "";
  }

  @computed
  get correctAnswerIsSelected() {
    return (
        (!this.props.userAnswer.step.hasCorrectAnswer && !isEmpty(this.props.userAnswer.answerValue)) ||
        (this.props.userAnswer.step.hasCorrectAnswer && this.props.userAnswer.step.correctAnswer === this.props.userAnswer.answerValue)
    )
  }

  render() {
    const { userAnswer } = this.props;
    return (
      <QuizQuestion>
        <p className={"visuallyhidden"} aria-live={"assertive"}>{this.wrongAnswer}</p>
        <div role="radiogroup" aria-labelledby={this.props.questionId}>
          {userAnswer.step.answers.map(
            (answer, index) => {
              const k = "answer-" + this.radioQuestionId + "-" + index;
              return (
                <RadioQuestionOption
                  radioOptionName={k}
                  correctAnswerIsSelected={this.correctAnswerIsSelected}
                  answerLocked={this.props.answerLocked}
                  onQuestionAnswered={this.handleQuestionAnswered}
                  onClearAnswerFeedback={this.handleClearAnswerFeedback}
                  key={k}
                  index={index}
                  selectedIndex={this.props.userAnswer.answerValue}>{answer.label}</RadioQuestionOption>
              );
            })
          }
        </div>

      </QuizQuestion>
    );
  }
}




